import { render, staticRenderFns } from "./CategoriesNew.vue?vue&type=template&id=43a819f3&scoped=true"
import script from "./CategoriesNew.vue?vue&type=script&lang=js"
export * from "./CategoriesNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a819f3",
  null
  
)

export default component.exports